module.exports = __webpack_public_path__ + "assets/aaaa682b58bf6676a3f290880172b592.png";